import React from "react";
import { MONTHS_IT, SEASON_MONTHS, SEASON_YEAR } from "../lib/season";

export default function MonthSelector({ month, onChange, testid = "month-selector" }) {
  return (
    <div data-testid={testid} className="flex flex-wrap gap-2">
      {SEASON_MONTHS.map((m) => (
        <button
          key={m}
          data-testid={`month-${m}`}
          onClick={() => onChange(m)}
          className={`h-11 rounded-lg px-4 text-sm font-semibold transition-colors ${
            month === m ? "bg-navy text-white" : "bg-white text-navy border border-slate-200 hover:border-gold"
          }`}
        >
          {MONTHS_IT[m]}
        </button>
      ))}
      <span className="flex h-11 items-center px-2 text-sm font-medium text-slate-400">{SEASON_YEAR}</span>
    </div>
  );
}
